import { render, staticRenderFns } from "./ChooseReplacement.vue?vue&type=template&id=ac35de36&"
import script from "./ChooseReplacement.vue?vue&type=script&lang=js&"
export * from "./ChooseReplacement.vue?vue&type=script&lang=js&"
import style0 from "./ChooseReplacement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3358805848/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac35de36')) {
      api.createRecord('ac35de36', component.options)
    } else {
      api.reload('ac35de36', component.options)
    }
    module.hot.accept("./ChooseReplacement.vue?vue&type=template&id=ac35de36&", function () {
      api.rerender('ac35de36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/ReplacementWidget/ChooseReplacement.vue"
export default component.exports